import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import { Controller, useFormContext } from 'react-hook-form';
import { useLanguages } from 'utils/ConstantsProvider';

export default function LanguageSelector({
  name = 'language_id',
  label = 'Language',
  required,
}: {
  name?: string;
  required?: boolean;
  label?: string;
}) {
  const form = useFormContext();

  const languages = useLanguages();

  return (
    <Controller
      rules={required ? { required: 'required' } : undefined}
      render={({ field }) => (
        <Label label={label}>
          <SelectSearchDropDown
            placeHolder="Select language"
            valueId={field.value}
            onChangeId={field.onChange}
            options={languages || []}
            optionItemSkin={(langugae) => langugae.name}
            selectedItemSkin={(langugae) => langugae.name}
            searchFilter={(needle, options) =>
              options.filter((o) =>
                o.name.toLowerCase().includes(needle.toLowerCase()),
              )
            }
          />
          <ErrorMessage
            errors={form.formState.errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        </Label>
      )}
      control={form.control}
      name={name}
    />
  );
}
